import { createFileRoute } from "@tanstack/react-router";
import {
  categoriesWithReferencesQueryOptions,
  finishedReferencesInfiniteQueryOptions,
} from "src/react-query/react-query";
import { InfiniteReferencesGrid } from "src/components/references/InfiniteReferencesGrid";
import { ReferenceFilter } from "src/components/references/ReferenceFilter";
import { seo } from "src/utils/seo";

export const Route = createFileRoute(
  "/_breadcrumbs/_referenceBreadcrumb/reference/",
)({
  component: RouteComponent,
  loader: async ({ context }) => {
    const [, rawCategories] = await Promise.all([
      context.queryClient.ensureInfiniteQueryData(
        finishedReferencesInfiniteQueryOptions(),
      ),
      context.queryClient.ensureQueryData(
        categoriesWithReferencesQueryOptions(),
      ),
    ]);

    return { rawCategories };
  },
  head: () => {
    return {
      meta: [
        ...seo({
          title: `Reference | VESAS`,
          description: `Reference naší stavební firmy VESAS`,
        }),
      ],
    };
  },
});

function RouteComponent() {
  const { rawCategories } = Route.useLoaderData();

  if (!rawCategories) {
    return <div>Žádné kategorie nebyly nalezeny</div>;
  }

  return (
    <div className={"container mx-auto"}>
      <ReferenceFilter defaultTabSlug={"vse"} rawCategories={rawCategories} />
      <InfiniteReferencesGrid />
    </div>
  );
}
